import React, { useState } from 'react';
import './input-form-border.css';
import '../../../css/icon-wellet.css';

const InputFormBorder = ({
  value,
  onChange,
  name,
  type,
  error,
  style,
  icon,
  placeholder,
  isDisabled = false,
  forceLowecase = false,
  onBlur,
  autoCapitalize = true,
  autoCorrect = true,
  spellCheck = true,
}) => {
  const className = `field-holder ${error ? 'error' : ''}`;
  const classInput = icon ? 'input-icon' : '';
  const [forceToShow, setForceToShow] = useState(false);

  return (
    <div className={className}>
      {icon && <i className={`icon-wellet-${icon}`} />}
      <div className='input-placeholder'>
        <input
          name={name}
          type={forceToShow ? 'text' : type}
          value={forceLowecase ? value?.toLowerCase() : value}
          onChange={onChange}
          className={`text-dark-gray  ${classInput}`}
          required
          style={style}
          disabled={isDisabled}
          onBlur={onBlur}
          autoCapitalize={autoCapitalize ? 'on' : 'off'}
          autoCorrect={autoCorrect ? 'on' : 'off'}
          spellCheck={spellCheck}
        />
        {placeholder && (
          <span
            className={`floating-placeholder ${classInput}`}
            dangerouslySetInnerHTML={{ __html: placeholder }}
          />
        )}
        {type === 'password' &&
          (!forceToShow ? (
            <span onClick={() => setForceToShow(true)} className={'reveal'}>
              <EyeHideIcon color={'#fff'} size={'21px'} />
            </span>
          ) : (
            <span onClick={() => setForceToShow(false)} className={'reveal'}>
              <EyeIcon color={'#fff'} size={'21px'} />
            </span>
          ))}
      </div>
      {error && error.length > 0 && <div className='error-label'>{error}</div>}
    </div>
  );
};

export default InputFormBorder;
